import React, { useState, useRef } from 'react';
import axios from 'axios';
import { Eye, EyeOff, Check, Circle } from 'lucide-react';
import { Sheet } from './AdminUi';

// Promjena lozinke (Profil, izbornik): panel s Odustani / Spremi i provjerom uvjeta dok tipkaš.
// Backend traži trenutnu lozinku samo ako je račun ima (prijava samo Googleom → prazno).

const MIN = 8;

function PwField({ id, label, value, onChange, show, onToggle, autoComplete, onEnter }) {
  return <>
    <label className="adm-fl" htmlFor={id}>{label}</label>
    <div className="pw-wrap">
      <input id={id} className="adm-input" type={show ? 'text' : 'password'} value={value} autoComplete={autoComplete}
        onChange={e => onChange(e.target.value)} onKeyDown={e => e.key === 'Enter' && onEnter && onEnter()} />
      <button type="button" className="pw-eye" onClick={onToggle} aria-label={show ? 'Sakrij lozinku' : 'Prikaži lozinku'}>
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  </>;
}

function ChangePasswordModal({ onClose }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const closeRef = useRef(null);

  const longEnough = next.length >= MIN;
  const matches = next.length > 0 && next === confirm;
  const missing = !longEnough ? `Najmanje ${MIN} znakova` : !matches ? 'Lozinke se ne podudaraju' : null;
  const dirty = !done && !!(current || next || confirm);

  const save = async () => {
    if (missing || busy) return;
    setBusy(true); setError('');
    try {
      await axios.post('/auth/change-password', { current_password: current, new_password: next }, { withCredentials: true });
      setDone(true);
      setTimeout(onClose, 1400);
    } catch (err) {
      setError(err.response?.data?.error || 'Promjena lozinke nije uspjela.');
      setBusy(false);
    }
  };

  const Req = ({ ok, children }) => (
    <li className={ok ? 'ok' : ''}>{ok ? <Check size={15} strokeWidth={3} /> : <Circle size={15} />}{children}</li>
  );

  return (
    <Sheet z={1200} onClose={onClose} dirty={dirty} busy={busy && !done} closeRef={closeRef}
      discardText="Nova lozinka nije spremljena."
      head={<div className="adm-sh"><div className="adm-main"><h3>Promjena lozinke</h3><p>Lozinkom se prijavljuješ e-mailom; prijava Googleom radi i dalje.</p></div></div>}
      footer={done ? (
        <div className="pw-done"><Check size={18} strokeWidth={3} /> Lozinka je promijenjena</div>
      ) : (
        <div className="adm-dirty">
          {error && <p style={{ color: '#ac463b' }}>{error}</p>}
          <div className="tf-foot">
            <button type="button" className="adm-btn" disabled={busy} onClick={() => closeRef.current && closeRef.current()}>Odustani</button>
            <button type="button" className={`adm-btn ${missing ? 'tf-off' : 'primary'}`} disabled={!!missing || busy} onClick={save}>
              {busy ? 'Spremam…' : missing || 'Spremi lozinku'}
            </button>
          </div>
        </div>
      )}
    >
      <PwField id="pw-current" label="Trenutna lozinka" value={current} onChange={v => { setCurrent(v); setError(''); }}
        show={show} onToggle={() => setShow(s => !s)} autoComplete="current-password" />
      <p className="adm-note" style={{ marginTop: -4 }}>Ako se dosad prijavljuješ samo Googleom, ostavi prazno.</p>
      <PwField id="pw-new" label="Nova lozinka" value={next} onChange={v => { setNext(v); setError(''); }}
        show={show} onToggle={() => setShow(s => !s)} autoComplete="new-password" />
      <PwField id="pw-confirm" label="Ponovi novu lozinku" value={confirm} onChange={v => { setConfirm(v); setError(''); }}
        show={show} onToggle={() => setShow(s => !s)} autoComplete="new-password" onEnter={save} />
      <ul className="pw-req">
        <Req ok={longEnough}>Najmanje {MIN} znakova</Req>
        <Req ok={matches}>Obje nove lozinke su iste</Req>
      </ul>
    </Sheet>
  );
}

export default ChangePasswordModal;
